export default {"src":"/_next/static/media/redCircle.ce985b60.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};